module.exports = __webpack_public_path__ + "05_short_black.a9bcc510.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/05_short_black.png
// module id = ZDBD
// module chunks = 0